import SpamCommentsList from './SpamCommentsList';

export default SpamCommentsList;
